import React from 'react';
import { useSelector } from 'react-redux';
import './GalleryRenderings.scss';
import GallerySlider from '../GallerySlider/GallerySlider';
import GallerySliderNew from '../GallerySliderNew/GallerySliderNew';
import Cover from '../Cover/Cover';
import MobileFooter from '../MobileFooter/MobileFooter';

function GalleryRenderings() {
    const content = useSelector((state) => state.content.pages);
    const isTouchScreen = useSelector((state) => state.utilities.isTouchScreen);

    if (typeof content.gallery !== 'undefined') {
        const renderings = content.gallery.renderings;

        return (
            <div className={`gallery-renderings${isTouchScreen ? " touchscreen" : ""}`}>
                <Cover />
                <GallerySliderNew renderings={renderings} />
                <MobileFooter showBelow={1301} />
            </div>
        );
    } else {
        return <div></div>;
    }
}

export default GalleryRenderings;
